import { Skeleton } from '@mui/material'

const EditContentUserQualificationsSkeleton = () => {
  return <Skeleton />
}

export default EditContentUserQualificationsSkeleton
